/**
 * Reads a value from window.__APP_CONFIG__ (public/config.js, tokens replaced
 * by Azure DevOps at release time), falling back to process.env for local dev.
 * Unsubstituted #{...} placeholders are treated as absent.
 */
function cfg(runtimeKey, envKey) {
  const runtimeVal = window.__APP_CONFIG__?.[runtimeKey];
  if (runtimeVal && !runtimeVal.startsWith('#{')) return runtimeVal;
  return process.env[envKey] || '';
}

// Base URL for the GCC Command Centre API — no trailing slash.
// Local dev: REACT_APP_GCC_API_URL in .env  (e.g. http://localhost:8001)
// Production: gcc_api_url token in public/config.js, replaced by Azure DevOps.
export const GCC_API_BASE_URL = cfg('gcc_api_url', 'REACT_APP_GCC_API_URL');

// Base URL for the GCC Studio AlphaSense proxy API — runs on a separate port.
// Local dev: REACT_APP_ALPHASENSE_API_URL in .env  (e.g. http://localhost:8001)
// Production: gcc_studio_api_url token in public/config.js, replaced by Azure DevOps.
export const GCC_STUDIO_API_BASE_URL = cfg('gcc_studio_api_url', 'REACT_APP_ALPHASENSE_API_URL');

// Base URL for the GCC Client Stories API (used by DBStories.jsx).
// Shares the same backend/token as GCC_STUDIO_API_BASE_URL — all Client
// Stories endpoints are served from the gcc_studio_api_url host.
// Local dev: REACT_APP_ALPHASENSE_API_URL in .env  (e.g. http://localhost:8001)
// Production: gcc_studio_api_url token in public/config.js, replaced by Azure DevOps.
export const CLIENT_STORIES_API_BASE_URL = GCC_STUDIO_API_BASE_URL;

// RSA public key (base64 DER / SPKI, single line) for hybrid request-payload
// encryption. Non-secret. The frontend RSA-wraps the per-request AES key with
// it, so no round-trip to the backend is needed to obtain it.
// Local dev: REACT_APP_CRYPTO_PUBLIC_KEY in .env
// Production: cryptoPublicKey token in public/config.js, replaced by Azure DevOps.
export const GCC_CRYPTO_PUBLIC_KEY = cfg('crypto_public_key', 'REACT_APP_CRYPTO_PUBLIC_KEY');
